import { render, staticRenderFns } from "./EqifyMenuDropdownItem.vue?vue&type=template&id=5b0fb872&scoped=true"
import script from "./EqifyMenuDropdownItem.vue?vue&type=script&lang=ts"
export * from "./EqifyMenuDropdownItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0fb872",
  null
  
)

export default component.exports